// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_gm-0";
export var fulfillmentPanelBody = "_gm-1";